<!--suppress ALL -->
<template>
  <g-field :label="hasSlotDefault || skipLabel ? '' : 'Kelas'"
           class="select-tahun-ajaran" :is-horizontal="hasSlotDefault">
    <label v-if="hasSlotDefault" class="label">{{$t('label.kelas')}}</label>
    <g-select :value="kelas" :placeholder="`Pilih kelas`"
              :disabled="disabled" @change="onChange" v-bind="$attrs">
      <option v-for="th in kelases" :key="th" :value="th">{{th}}</option>
    </g-select>
    <slot></slot>
  </g-field>
</template>

<script lang="ts">
	import {Component, Prop, Vue} from 'annotation';
	import {kelases} from '../../../util/PluralVariabels';

	@Component
	export default class SelectKelas extends Vue {

		@Prop({type: String})
		public kelas: string;

		@Prop({type: Boolean, default: false})
		public disabled: boolean;

    @Prop({type: Boolean, default: false})
    public skipLabel: boolean;

		public kelases: Array<any> = kelases;

		public onChange(val) {
			this.$emit('update:kelas', val);
			this.$emit('kelas-selected', val);
		}

		public get hasSlotDefault() {
			return this.$scopedSlots.default || this.$slots.default;
		}
	}
</script>

<style lang="scss">
  .select-tahun-ajaran {
    .select, select {
      min-width: 200px;
      width: 100%;
    }
    &.is-horizontal {
      .field-body {
        align-items: center;
        .field {
          &:first-child {
            width: 150px;
          }
          flex: none;
        }
      }
    }
  }
</style>
